<template>
    <erros-box :erros="erros"></erros-box>
    <div class="grid">
        <div class="col-12 mb-4">
            <tabela :data="recursosFinanceiros.aportes" :mostrarPesquisa="false" :mostrarHeader="false" :sortField="'index'" :sortOrder="1" :paginator="false">
                <template #conteudo>
                    <Column v-for="coluna of colunas.aportes" :key="coluna.index" :field="coluna.field" :header="coluna.header" :sortable="false" />
                </template>
            </tabela>
        </div>
        <div class="col-12">
            <tabela
                :data="recursosFinanceiros.planoDeTrabalho"
                :mostrarPesquisa="false"
                :mostrarHeader="false"
                :sortField="'index'"
                :sortOrder="1"
                :paginator="false"
            >
                <template #conteudo>
                    <Column v-for="coluna of colunas.planoDeTrabalho" :key="coluna.index" :field="coluna.field" :header="coluna.header" :sortable="false" />
                </template>
            </tabela>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            erros: [],
            colunas: {
                aportes: [
                    { index: 1, field: 'acao', header: '' },
                    { index: 2, field: 'aporteSebrae', header: 'Aporte Sebrae' },
                    { index: 3, field: 'aporteParceiro', header: 'Aporte Parceiro' },
                    { index: 4, field: 'empresasBeneficiadas', header: 'Empresas Beneficiadas' },
                    { index: 5, field: 'rendimentos', header: 'Rendimentos' },
                ],
                planoDeTrabalho: [
                    { index: 1, field: 'planoDeTrabalhoAcoes', header: 'Plano de Trabalho - Ações' },
                    { index: 2, field: 'previsto', header: 'Previsto' },
                    { index: 3, field: 'realizado', header: 'Realizado' },
                    { index: 4, field: 'porcentagem', header: '%' },
                ],
            },
        };
    },
    props: {
        recursosFinanceiros: { type: Object, default: () => {} },
    },
};
</script>
